import RawDataQCParameters, { defaultValues as rawDataQCDefaults, validate as validateRawDataQC } from "./RawDataQCParameters";
import VariantAnalysisParameters, { defaultValues as variantDefaults, validate as validateVariantAnalysis } from "./VariantAnalysisParameters";
import ExomeTargetedSeqParameters, { defaultValues as exomeDefaults, validate as validateExomeTargeted } from "./ExomeTargetedSeqParameters";
import ChIPSeqParameters, { defaultValues as chipseqDefaults, validate as validateChIPSeq } from "./ChIPSeqParameters";
import MetagenomicsParameters, { defaultValues as metagenomeDefaults, validate as validateMetagenomics } from "./MetagenomicsParameters";
import TranscriptomeResequencingParameters, { defaultValues as transcriptomeResequencingDefaults, validate as validateTranscriptomeResequencing } from "./TranscriptomeResequencingParameters";
import GenericParameters from "./GenericParameters";

const PARAMETER_COMPONENTS = {
  "raw-data-qc": RawDataQCParameters,
  "variant-analysis": VariantAnalysisParameters,
  "exome-targeted": ExomeTargetedSeqParameters,
  chipseq: ChIPSeqParameters,
  metagenome: MetagenomicsParameters,
  transcriptome: TranscriptomeResequencingParameters,
  "transcriptome-resequencing": TranscriptomeResequencingParameters,
};

export function getDefaultParameterValues(moduleKey) {
  switch (moduleKey) {
    case "raw-data-qc":
      return rawDataQCDefaults;
    case "variant-analysis":
      return variantDefaults;
    case "exome-targeted":
      return exomeDefaults;
    case "chipseq":
      return chipseqDefaults;
    case "metagenome":
      return metagenomeDefaults;
    case "transcriptome":
    case "transcriptome-resequencing":
      return transcriptomeResequencingDefaults;
    case "rna-seq":
      return rnaSeqDefaults;
    case "genome-annotation":
      return genomeDefaults;
    case "gene-annotation":
      return geneDefaults;
    default:
      return {};
  }
}

export function getParameterErrors(moduleKey, values = {}) {
  switch (moduleKey) {
    case "raw-data-qc":
      return validateRawDataQC(values);
    case "variant-analysis":
      return validateVariantAnalysis(values);
    case "exome-targeted":
      return validateExomeTargeted(values);
    case "chipseq":
      return validateChIPSeq(values);
    case "metagenome":
      return validateMetagenomics(values);
    case "transcriptome":
    case "transcriptome-resequencing":
      return validateTranscriptomeResequencing(values);
    case "rna-seq":
      return validateRNASeq(values);
    case "genome-annotation":
      return validateGenomeAnnotation(values);
    case "gene-annotation":
      return validateGeneAnnotation(values);
    default:
      return {};
  }
}

export default function ParametersStep({
  moduleKey,
  values,
  onChange,
  errors,
  expectedSamples,
}) {
  const Component = PARAMETER_COMPONENTS[moduleKey] || GenericParameters;
  return (
    <Component
      values={values}
      onChange={onChange}
      errors={errors}
      expectedSamples={expectedSamples}
    />
  );
}
